import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('enable_twofactor_authentication_now'),
    descriptionAdministratorEnforcement: defineMessage('to_continue_using_appro_l_you_complete_fa_setup'),
    descriptionCompanyEnforcement: defineMessage('your_organisations_admi_anisation_set_up_fa_now'),
    button: defineMessage('set_up_twofactor_authentication_1'),
    logOut: defineMessage('log_out'),
    moreInformation: defineMessage('for_more_information_pl_support_teamsupportlink'),
};
